/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelSystemComponent } from './panel-system.component';
import { DxSelectBoxModule } from 'devextreme-angular';
import { SysqueCheckBoxContainerModule } from '../../../../../../../shared/ui/src/lib/components/sysque-check-box-container';

@NgModule({
  declarations: [PanelSystemComponent],
  imports: [CommonModule, DxSelectBoxModule, SysqueCheckBoxContainerModule],
  exports: [PanelSystemComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PanelSystemModule {}
